import { useQuery, gql } from "@apollo/client";
import { TEMPLATE_FRAGMENT } from './useGetTemplate';

export const GET_TEMPLATES = gql`
  query getTemplates(
    $madId: ID
  ) {
    templates(
      madId: $madId
    ) {
      collection {
        ...TemplateFragment
      }
    }
  }
  ${TEMPLATE_FRAGMENT}
`;

export default (options) => {
  return useQuery(GET_TEMPLATES, options);
};
